import {Component, inject} from '@angular/core';
import {StorageService} from "../../../../../projects/vendors/src/lib/services/storage.service";

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrl: './profile.component.scss',
    standalone: false
})
export class ProfileComponent {

  storageService = inject(StorageService);

  get userDetails() {
    return this.storageService.getFromSessionStorage('userDetails') || {};
  }

  get roles(): string[] {
    return this.storageService.getFromSessionStorage('roles') || [];
  }
}
